import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveInAppNavigationPath } from '@vastra/utils';

/**
 * Intercept same-origin <a> clicks (e.g. Quill HTML) and use React Router
 * instead of a full page load / new tab.
 */
export function useInAppHtmlLinkNavigation(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const target = e.target;
      if (!(target instanceof Element)) return;
      const anchor = target.closest('a');
      if (!anchor || !(anchor instanceof HTMLAnchorElement)) return;
      if (anchor.hasAttribute('download')) return;
      if (anchor.getAttribute('data-spa') === 'false') return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      const path = resolveInAppNavigationPath(href);
      if (!path) return;

      e.preventDefault();
      navigate(path);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [navigate]);
}
